<template>
  <section>
    <!-- 최상단 이동 앵커 -->
    <!--    <a href="#" class="footer-top-anchor">-->
    <!--      ▲トップへ&nbsp&nbsp-->
    <!--    </a>-->

    <!-- footer 테이블 -->
    <footer>
      <table class="footer-content" border="0" cellpadding="0" cellspacing="0">
        <tr>
          <!-- 1) Copyright & 인증마크 -->
          <td
              width="290px"
              align="left"
              valign="top"
              class="footer-content__copyright-column"
              style="font-size: 13px; line-height: 1.1"
          >
            <ul style="margin-top: 15px">
              <li>
                <h2
                    class="company-title"
                    style="line-height: 0.5; padding-top: 23px"
                >
                  株式会社ダイレクトクラウド
                </h2>
              </li>
              <li style="line-height: 1.2; padding-bottom: 9px">
                DirectCloud, Inc<br/>
                Copyright © 2014-{{ year }} DirectCloud, Inc.<br/>
                All Rights Reserved.
              </li>
              <li>
                <img :src="isms_logo_top" alt="isms sgs privacy logo"/>
              </li>
              <li>
                <img :src="isms_logo_bottom" alt="isms sgs logo"/>
              </li>
            </ul>
          </td>

          <!-- 2) 웹페이지 링크들 -->
          <td></td>
          <td align="center" valign="top">
            <table class="footer-content__column">
              <!-- 2-1) 製品情報 -->
              <td>
                <h3>製品情報</h3>
                <ul>
                  <li><a href="/about/features#dc_features">特徴</a></li>
                  <li><a href="/compare#dc_compare">他社比較</a></li>
                  <li><a href="/about/func#dc_func">主要機能</a></li>
                  <li><a href="/contents/">コンテンツ</a></li>
                  <li><a href="/option#dc_option">オプションサービス</a></li>
                  <li><a href="/service#dc_service">利用料金</a></li>
                  <li><a href="/adoption">実績</a></li>
                  <li><a href="/interview">導入事例</a></li>
                  <li><a href="/about/util#dc_util">利用シーン</a></li>
                </ul>
              </td>

              <!-- 2-2) サービス利用 -->
              <td>
                <h3>サービス利用</h3>
                <ul>
                  <li>
                    <a href="/support/qna_before">導入前のお問い合わせ</a>
                  </li>
                  <li>
                    <a href="/contents/category/doc_download/"
                    >資料ダウンロード</a
                    >
                  </li>
                  <li>
                    <a href="/apply/trial?plan=undecided">無料トライアル</a>
                  </li>
                  <li><a href="/apply">お申込み</a></li>
                  <li>
                    <a href="https://boxmanager.directcloud.jp/">管理ページ</a>
                  </li>
                </ul>
              </td>

              <!-- 2-3) サポートセンター -->
              <td>
                <h3>サポートセンター</h3>
                <ul>
                  <li><a href="/support/manual">ヘルプドキュメント</a></li>
                  <li><a href="/download">ダウンロード</a></li>
                  <li><a href="/support/faq">よくある質問</a></li>
                  <li><a href="/support/qna_after">導入後のお問い合わせ</a></li>
                  <li><a href="/support/maintenance">メンテナンス情報</a></li>
                  <li><a href="/support/system">動作環境</a></li>
                  <li><a href="/onlinedemo">遠隔支援サービス</a></li>
                </ul>
              </td>

              <!-- 2-4) お知らせ -->
              <td>
                <h3>お知らせ</h3>
                <ul>
                  <li><a href="/notice">お知らせ</a></li>
                  <li><a href="/support/maintenance">メンテナンス情報</a></li>
                  <li><a href="/event_schedule">イベント情報</a></li>
                </ul>
              </td>

              <!-- 2-5) その他 -->
              <td>
                <h3>その他</h3>
                <ul>
                  <li><a href="/support/partner">パートナー募集</a></li>
                  <li>
                    <a href="/support/business_partner">販売パートナーの紹介</a>
                  </li>
                  <li><a href="/commerce">特定商取引に基づく表記</a></li>
                  <li>
                    <a href="https://directcloud.co.jp/houshin"
                    >個人情報保護方針</a
                    >
                  </li>
                  <li><a href="/terms">利用規約</a></li>
                  <li><a href="/overview">サービス概要</a></li>
                  <li><a href="/overview">サービス品質保証制度</a></li>
                  <li><a href="/availability_report">サーバー稼働率</a></li>
                  <li><a href="/sitemap">サイトマップ</a></li>
                </ul>
              </td>

              <!-- 2-6) 会社情報 -->
              <td>
                <h3>会社情報</h3>
                <ul>
                  <li>
                    <a href="https://www.directcloud.co.jp/company">会社概要</a>
                  </li>
                  <li>
                    <a href="https://www.directcloud.co.jp/company/#com-access"
                    >アクセス</a
                    >
                  </li>
                </ul>
              </td>
            </table>
            <!-- 2) -->
          </td>
        </tr>
      </table>
    </footer>
  </section>
</template>

<script>

const isms_logo_top = new URL('../data/image/mark-logo_api_top.png', import.meta.url)
const isms_logo_bottom = new URL('../data/image/mark-logo_api_bottom.png', import.meta.url);

export default {
  name: 'Footer',
  data: function () {
    return {
      year: new Date().getFullYear(),
      isms_logo_top: isms_logo_top.pathname,
      isms_logo_bottom: isms_logo_bottom.pathname
    };
  },
};
</script>

<style scoped lang="scss">
.footer-top-anchor {
  text-decoration: none;
  font-size: 1rem;
  color: grey;
  text-align: right;
  width: 100%;
  display: inline-block;
  box-sizing: inherit;
  padding-bottom: 20px;
}

footer {
  background-color: #3674b7;
  border-top: 1px solid;
  color: #e4eef9 !important;
  position: relative;
  z-index: 1;
  padding: 10px 0px;

  .footer-content {
    width: 1250px;
    margin: auto;

    border-collapse: separate;
    box-sizing: border-box;

    .tbody {
      display: table-row-group;
      vertical-align: middle;
      border-color: inherit;

      tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
      }
    }

    .footer-content__column {
      td {
        padding: 12px 21px;
      }

      h3 {
        color: #e4eef9;
        font-size: 1.15rem;
        font-weight: 600;
      }
    }
  }
}

ul {
  list-style-type: none;
  line-height: 1.4rem;
  padding: 0;

  h2 {
    color: #e4eef9;
    font-weight: 600;
  }

  a {
    text-decoration: none;
    color: #e4eef9;
  }

  a:hover {
    color: rgba(136, 198, 255);
    text-decoration: underline;
  }
}
</style>
